import script from "./ProductNutritionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductNutritionTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductNutritionTable.vue?vue&type=style&index=0&id=ad6fbbf8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad6fbbf8"]])

export default __exports__